exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__spacer___11Iat{height:1px}.style__xl___2K5ph{padding-top:70px;padding-bottom:70px}.style__lg___q7L8B{padding-top:50px;padding-bottom:50px}.style__md___1xwbT{padding-top:40px;padding-bottom:40px}.style__sm___QS2RP{padding-top:25px;padding-bottom:25px}.style__xs___1XLTS{padding-top:15px;padding-bottom:15px}.style__xxs___3YGbY{padding-top:10px;padding-bottom:10px}@media (max-width:1200px){.style__xl___2K5ph{padding-top:60px;padding-bottom:60px}.style__lg___q7L8B{padding-top:40px;padding-bottom:40px}.style__md___1xwbT{padding-top:30px;padding-bottom:30px}.style__sm___QS2RP{padding-top:20px;padding-bottom:20px}.style__xs___1XLTS{padding-top:12px;padding-bottom:12px}}@media (max-width:700px){.style__xl___2K5ph{padding-top:35px;padding-bottom:35px}.style__lg___q7L8B{padding-top:25px;padding-bottom:25px}.style__md___1xwbT{padding-top:20px;padding-bottom:20px}.style__sm___QS2RP{padding-top:12px;padding-bottom:12px}.style__xs___1XLTS{padding-top:8px;padding-bottom:8px}}", ""]);

// exports
exports.locals = {
	"spacer": "style__spacer___11Iat",
	"xl": "style__xl___2K5ph",
	"lg": "style__lg___q7L8B",
	"md": "style__md___1xwbT",
	"sm": "style__sm___QS2RP",
	"xs": "style__xs___1XLTS",
	"xxs": "style__xxs___3YGbY"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/spacer/style.css
// module id = 709
// module chunks = 0